import { render, staticRenderFns } from "./ConfirmRegister.vue?vue&type=template&id=4ddfb724"
import script from "./ConfirmRegister.vue?vue&type=script&lang=js"
export * from "./ConfirmRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports